"use strict";

const _ = require('underscore');
const SoaModel = require('bunsen/models/SoaModel');
const User = require('bunsen/models/identity/User');
const Seller = require('bunsen/models/Seller');
const assert = require('bunsen/helpers/assert');

/**
 * This version of the authorized role model only applies to users (not sellers). isPermitted checks happen based
 * on user permissions.
 * @type {Function}
 */
const AuthorizedAdminRole = SoaModel.extend({

    /**
     * Determines whether or not a given user has any of the permissions present in the authorized role. If a user
     * has one of the defined permissions, then they are authorized to take that action.
     * @param userOrSeller
     * @returns {*}
     */
    isPermitted(user) {
        let isUser = user instanceof User;
        let isSeller = user instanceof Seller;
        let permissions = this.get('permissions');
        permissions = _.flatten([permissions]);

        if (isSeller) {
            return false;
        }

        assert(isUser, 'isPermitted requires a real instance of a user model');

        return user.hasPermission(permissions);
    }

});

module.exports = AuthorizedAdminRole;



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/AuthorizedAdminRole.es.js